// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2Qtjs","messages":"Chat_messages__30tHg","dateDivider":"Chat_dateDivider__q-f7e"};